<div class="modal-header">
  <div class="col-lg-6">
    <div class="text-header inc-f">
      <span class="fa fa-list"></span> Self Assessment Workflow
    </div>
  </div>
  <div class="col-lg-6 f-15">
    <button
      class="fa fa-times pull-right"
      style="cursor: pointer; background: none; border: none"
      aria-hidden="true"
      (click)="closeDialog()"
    ></button>
    <!-- <button class="fa fa-times pull-right" [mat-dialog-close]=""
            style="cursor: pointer;background: none;border:none" aria-hidden="true"></button> -->
    <a
      *ngIf="templateNo == 1"
      href="/self-assessment/details/self/{{ id }}"
      target="_blank"
    >
      <span
        class="fa fa-external-link pull-right external"
        title="Open in New Window"
      ></span>
    </a>
    <a
      *ngIf="templateNo == 2"
      href="/self-assessment/details/self/2/{{ id }}"
      target="_blank"
    >
      <span
        class="fa fa-external-link pull-right external"
        title="Open in New Window"
      ></span>
    </a>
    <a
      *ngIf="templateNo == 3"
      href="/self-assessment/details/self/3/{{ id }}"
      target="_blank"
    >
      <span
        class="fa fa-external-link pull-right external"
        title="Open in New Window"
      ></span>
    </a>
  </div>
</div>
<div class="modal-body">
  <app-assessment-details
    *ngIf="templateNo == 1"
    [selfAssessmentId]="id"
    [filterType]="assessmentType"
  ></app-assessment-details>
  <app-self-assessment-t2-details
    *ngIf="templateNo == 2"
    [selfAssessmentId]="id"
    [filterType]="assessmentType"
  ></app-self-assessment-t2-details>
  <app-self-assessment-details
    *ngIf="templateNo == 3"
    [selfAssessmentId]="id"
  ></app-self-assessment-details>
</div>
